import CookieConsent from "react-cookie-consent";
import { useTranslation, Trans } from "react-i18next";
import { Link } from "react-router";

export default function CookieConsentBanner() {
    const { t } = useTranslation();

    return (
        <CookieConsent
            location="bottom"
            buttonText={t("gdpr.accept")}
            declineButtonText={t("gdpr.decline")}
            enableDeclineButton
            cookieName="alchely-cookie-consent"
            style={{ background: "#1F2937", alignItems: "center" }}
            buttonStyle={{
                background: "#4F46E5",
                color: "white",
                fontSize: "14px",
                borderRadius: "8px",
                fontWeight: "600",
                padding: "8px 16px",
            }}
            declineButtonStyle={{
                background: "transparent",
                color: "#9CA3AF",
                fontSize: "14px",
                borderRadius: "8px",
                border: "1px solid #4B5563",
                padding: "8px 16px",
                marginRight: "10px",
            }}
            expires={150}
        >
            <div className="flex flex-col gap-1">
                <span className="font-semibold text-white">Cookies 🍪</span>
                <span className="text-sm text-gray-300">
                    <Trans i18nKey="gdpr.cookieMessage">
                        We use cookies to enhance your user experience. By continuing to visit this site you agree to our use of cookies.
                    </Trans>{" "}
                    <Link to="/privacy" className="underline text-brand-400 hover:text-brand-300">
                        {t("legal.privacyTitle")}
                    </Link>
                </span>
            </div>
        </CookieConsent>
    );
}
